<template>
 <v-dialog :value="true" persistent max-width="650px" scrollable hide-overlay>
    <v-card class="register">
      <v-card-title class="gradient elevation-3">
        <v-toolbar-title style="color: white">
          <v-icon color="white">person</v-icon>
          Bem Vindo! Coloque seus dados para se registrar
        </v-toolbar-title>
      </v-card-title>
      <v-card-text>
        <v-alert :type="snackbar.color" :icon="snackbar.color" dismissible v-model="snackbar.active" transition="scale-transition">
          {{ snackbar.text }}
        </v-alert>
        <v-flex v-if="this.user.company_id != ''" xs12 class="text-xs-center">
          <v-avatar size="125px" v-if="companyInfo['logo_path']">
            <img :src="`${basePath}uploads/companies/${companyInfo['logo_path']}`" alt="Logo">
          </v-avatar>
          <br>
          <h4>{{companyInfo['id_text']}}</h4>
        </v-flex>
        <v-layout v-if="registerNext" justify-start align-center row wrap>
          <!-- // caso tenha o company então pede o nome do usuário pos significa que é um convite de uma empresa -->
          <v-flex v-if="this.user.company_id != ''" xs12 class="text-xs-center">
            <v-text-field required prepend-icon="person" name="name" label="Seu nome*" type="text" autofocus
            v-model="user.id_text"
            :error-messages="errors.collect('name')"
            data-vv-validate-on="none"
            v-validate="'required'"
            data-vv-as="Nome"
            />
          </v-flex>
          <!-- // caso não tenha o company_id então pede o telefone, seguindo o fluxo normal -->
          <v-flex v-else xs12 class="flex_field">
            <v-text-field required label="Telefone*"
            autocomplete="tel"
            mask='(##) #####-####'
            v-model="user.phone"
            prepend-icon="phone"
            name="phone"
            @click="cleanErrors('phone')"
            :error-messages="errors.collect('phone')"
            data-vv-validate-on="none"
            @keyup.native.enter="confirmRegister()"
            v-validate="'required'"
            data-vv-as="Telefone"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 class="flex_field">
            <v-text-field required prepend-icon="lock" name="password" label="Senha*" id="password"
            :type="showPassword ? 'text' : 'password'"
            v-model="user.password"
            :error-messages="errors.collect('password')"
            @click="cleanErrors('password')"
            data-vv-validate-on="none"
            v-validate="'required|min:6'" @keyup.native.enter="confirmRegister()"
            data-vv-as="Senha"
            />
          </v-flex>
          <v-flex xs12 sm6 class="flex_field">
            <v-text-field prepend-icon="check" name="confirmation" label="Confirmação*" id="confirmation"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
            @click:append="showPassword = !showPassword"
            v-model="user.confirmation"
            :error-messages="errors.collect('confirmation')"
            @click="cleanErrors('confirmation')"
            data-vv-validate-on="none" @keyup.native.enter="confirmRegister()"
            v-validate="'required|min:6'"
            data-vv-as="Confirmação"
            required/>
          </v-flex>
          <small class="required-field">* indica campos obrigatórios</small>
          <v-flex xs12>
            Ao me cadastrar, concordo com a
            <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <a
              target="_blank"
              :href="`https://app.api.illis.com.br/terms/temos.html`"
              @click.stop
              v-on="on"
              >
              Política de privacidade e o Termo de serviço
              </a>
            </template>
            Abrir em um nova janela
            </v-tooltip>
            da Illis Soluções.
          </v-flex>
        </v-layout>
        <v-layout v-else row justify-start align-center wrap>
          <v-flex xs12 class="flex_field">
            <v-text-field required prepend-icon="mail" name="mail" label="E-mail*" type="text"
                          v-model="user.email"
                          :disabled="company_user['id'] !== ''"
                          :error-messages="errors.collect('mail')"
                          @click="cleanErrors('mail')"
                          @blur="validateEmailBlur(user.email)"
                          data-vv-validate-on="none"
                          v-validate="'required|email'" @keyup.native.enter="beforeRegister()"
                          data-vv-as="E-mail"
                          data-vv-delay="1000"

            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="ma-2">
        <v-flex v-if="registerNext" xs12 class="text-xs-center">
          <v-btn dark class="gradient" @click="confirmRegister()" :loading="loading">Confirmar</v-btn>
          <v-btn flat @click="registerNext = false">Voltar</v-btn>
        </v-flex>
        <v-flex v-else xs12 class="text-xs-center">
          <v-btn dark class="gradient" @click="beforeRegister()" :loading="loading">Prosseguir</v-btn>
          <v-btn v-if="company_user['company_id'] === ''" flat @click="clickReturn()">Voltar</v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
  .register {
    border-radius:20px;
  }

  .gradient {
    background: linear-gradient(40deg, #4a97ce, #5fbf8d);
  }

  .flex_field {
    padding-bottom: 0px;
    padding-top: 0px;
  }

  .required-field {
    padding-left: 8px;
  }
</style>

<script>
  /* eslint-disable no-useless-escape */
  import Card from '../shared/Card'
  import { Validator } from 'vee-validate'

  export default {
    components: {Card},
    data: () => ({
      code: '',
      return: 'tasks',
      loading: false,
      showPassword: false,
      registerNext: false,
      companyInfo: {id: '', id_text: '', logo_path: ''},
      confirmation_screen: false,
      basePath: process.env.API,
      registerData: {},
      company_user: {
        id: '',
        company_id: '',
        user_id: '',
        status: '',
        admin: '',
        access_id: '',
        filter: '{}'
      },
      company: {
        id_text: '',
        active: true,
        type_person: 2
      },
      user: {
        id: '',
        id_text: '',
        email: '',
        code: 'FIRST',
        phone: '',
        password: '',
        company_id: '',
        confirmation: ''
      },
      user_tracking: {
        company_id: '',
        utm_source: '',
        utm_medium: '',
        utm_campaign: '',
        utm_content: '',
        utm_term: ''
      },
      snackbar: {
        active: false,
        text: 'Solicitação realizada com sucesso',
        color: 'success'
      }
    }),
    props: {
      source: String
    },
    created () {
      // Se o usuário estiver logado vai pra tela de tarefas
      if (this.$auth.check()) {
        this.$router.push('/tasks')
      }
      Validator.extend('verify_email', {
        getMessage: field => `O email "${field}" já foi cadastrado.`,
        validate: value => new Promise((resolve) => {
          this.$http.get(`auth/check_user`, {params: {email: value}}).then(res => {
            resolve({
              valid: res.body.length === 0
            })
          })
        })
      })
      // Verifica se tem um atributo com o nome return, pois caso tenha, apos fazer o register, vai para a tela do return
      if (this.$route.query.return) {
        this.return = this.$route.query.return
      }
      if (this.$route.params.data) {
        var values = atob(this.$route.params.data).split('|')
        this.user.email = values[0]
        this.user.company_id = values[2] ? parseInt(values[2]) : ''
        this.company_user.id = values[1] ? parseInt(values[1]) : ''
        this.company_user.company_id = values[2] ? parseInt(values[2]) : ''
        this.company_user.admin = values[3] ? parseInt(values[3]) : ''
        this.company_user.access_id = values[4] ? parseInt(values[4]) : ''

        this.$http.get(`api/company_info_simple/${this.user.company_id}`).then(res => {
          this.companyInfo = res.body
        }, err => {
          console.log(err)
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível carregar os dados da empresa, reporte o erro.',
            color: 'error',
            dialog: true
          })
        })
      } else if (this.$route.query.email) {
        this.user.email = this.$route.query.email
      }

      // estrutura utm criada para rastrear de qual campanha e qual termo o usuário usou
      let query = this.$route.query
      if (this.$route.query.utm_term) {
        this.user_tracking.utm_source = query.utm_source ? query.utm_source : ''
        this.user_tracking.utm_medium = query.utm_medium ? query.utm_medium : ''
        this.user_tracking.utm_campaign = query.utm_campaign ? query.utm_campaign : ''
        this.user_tracking.utm_content = query.utm_content ? query.utm_content : ''
        this.user_tracking.utm_term = query.utm_term ? query.utm_term : ''
      }
    },
    methods: {
      validateEmailBlur (item) {
        this.user.email = item.replace(/\s/g, '')
      },
      cleanErrors (field) {
        this.errors.remove(field)
      },
      beforeRegister () {
        this.loading = true
        this.$validator.validateAll().then((result) => {
          if (result) {
            // Validação se o email do usuário já existe
            this.$http.get('auth/verify_email_register/' + this.user.email).then((res) => {
              if (parseInt(res.body) === 1) {
                this.$store.commit('snackbar/change_values', {
                  text: 'Porfavor, corrija as validações para continuar',
                  color: 'warning',
                  dialog: true,
                  timeout: 6000
                })
                this.errors.add({
                  field: 'mail',
                  msg: 'Este email já foi cadastrado'
                })
                this.loading = false
                return 0
              }
              this.loading = false
              this.registerNext = true
            },
            (err) => {
              console.log(err)
              this.$store.commit('snackbar/change_values', {
                text: 'Não foi possível verificar os dados, tente novamente mais tarde ou contate o suporte',
                color: 'error',
                dialog: true
              })
              this.loading = false
            })
          } else {
            this.$store.commit('snackbar/change_values', {
              text: 'Por favor, corrija as validações antes de salvar!',
              color: 'error',
              dialog: true
            })
            this.loading = false
          }
        })
      },
      confirmRegister () {
        // Validação se as senhas estão iguais
        if (this.user.password !== this.user.confirmation) {
          this.$store.commit('snackbar/change_values', {
            text: 'Porfavor, corrija as validações para continuar',
            color: 'warning',
            dialog: true,
            timeout: 6000
          })
          this.errors.add({
            field: 'confirmation',
            msg: 'As senhas não se coincidem'
          })
          this.loading = false
          return 0
        }
        this.loading = true
        this.$validator.validateAll().then((result) => {
          if (result) {
            let phoneValidation = true
            // Caso tenha company_id não precisa validar o telefone, pois quando é um convite de um empresa, não pede telefone
            if (this.company_user['company_id'] === '') {
              // phoneValidation que faz validação do número de celular do campo phone no cadastro, difere se é fixo ou móvel.
              // Ela valida DDD, DDD VAI DE 11 ATÉ 99 https://pt.wikipedia.org/wiki/N%C3%BAmeros_de_telefone_no_Brasil (Tratar questão dos zeros)
              // Quantidade de digitos, 8 para fixo e 9 para movél(Telefone móvel primeiro digito é sempre o 9, telefone fixo primeiro varia de 2 ao 9)
              phoneValidation = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$/gi.test(this.user['phone'])
              // Verificação se o número de telefone tem 7 dígitos iguais sequenciais
              if (this.user['phone'].includes('0000000') || this.user['phone'].includes('1111111') || this.user['phone'].includes('2222222') || this.user['phone'].includes('3333333') || this.user['phone'].includes('4444444') || this.user['phone'].includes('5555555') || this.user['phone'].includes('6666666') || this.user['phone'].includes('7777777') || this.user['phone'].includes('8888888') || this.user['phone'].includes('9999999')) phoneValidation = false
            }
            if (phoneValidation) {
              this.loading = false
              // no caso de não ter nome do usuário, pois agora o usuário inclui o nome dentro do sistema, então adiciona o inicio do email como o nome
              if (this.user['id_text'] === '') {
                let name = this.user['email'].split('@')[0]
                this.user['id_text'] = name
              }
              if (this.company['id_text'] === '') {
                // Separa o nome do uusário para colocar no preprenchimento do nome da empresa
                let words = (this.user['id_text'].trim()).split(' ')
                this.company['id_text'] = `Empresa de ${words[0]}`
              }
              // variavel values estrutura os valore para cria a emrpesa e os complementos de quando registra
              this.registerData = {
                user: this.user,
                companyUser: this.company_user,
                company: this.company,
                userTracking: this.user_tracking,
                // insere o email e password para já entrar automatico, pq tem que estar no primeiro nivel do regisreData
                password: this.user['password'],
                email: this.user['email']
              }
              // OO code representa  a primeira vez que o usuário entra, se for apenas first significa que é um registro normal, se for FIRSTGUEST significa que é um registro por um convite.
              this.user['code'] = this.company_user['company_id'] === '' ? 'FIRST' : 'FIRSTGUEST'
              this.register()
            } else {
              this.errors.add({
                field: 'phone',
                msg: 'Este número não é válido'
              })
              this.loading = false
              return 0
            }
          } else {
            this.$store.commit('snackbar/change_values', {
              text: 'Por favor, corrija as validações antes de salvar!',
              color: 'error',
              dialog: true
            })
            this.loading = false
          }
        })
      },
      register: function () {
        this.loading = true
        this.$store.commit('loader/change_dialog', true)
        this.$auth.register({
          body: this.registerData,
          autoLogin: true,
          staySignedIn: true,
          fetchUser: true
        }).then((res) => {
          this.$store.commit('snackbar/change_values', {
            text: 'Usuário cadastrado com sucesso!',
            color: 'success',
            dialog: true
          })
          this.snackbar = {
            active: true,
            text: 'Solicitação realizada com sucesso',
            color: 'success'
          }
          Object.assign(this.user, res.body.data['user'])
          // Manda o socket apenas se foi um registro de uma empresa nova
          if (this.company_user.company_id !== '') {
            // recebe os valores que vem do back, pois caso venha de um registro por um link geral, fica faltando alguns dados, sendo obtidos pelo res.body.data['companyUser']
            this.company_user = res.body.data['companyUser']
            // Montanto objeto com informações do usuário pois é necessário para o socket atualizar a lista de participantes
            // da empresa para os outros participantes.
            this.company_user.user = {
              id: this.company_user.user_id,
              id_text: this.user.id_text,
              email: this.user.email
            }
            // o Socket é para inserir os usuários na empresa ( Gerenciamento de Empresa)
            this.$socket.emit('generalDetailsEvent', {
              data: this.company_user,
              details: 'users',
              responseEvent: 'addSocketDetails',
              room: `companies${this.company_user.company_id}_manage` // * Tela de gerenciamento
            })
            // o Socket é para inserir os usuários na empresa (Participantes da Empresa)
            this.$socket.emit('generalDetailsEvent', {
              data: this.company_user,
              details: 'users',
              responseEvent: 'addSocketDetailsCompanyUser',
              room: `companies${this.company_user.company_id}_manage` // * Tela de gerenciamento
            })
          }
          this.$router.push('tasks')
          this.loading = false
          this.$store.commit('loader/change_dialog', false)
          // ---------- ILLISTODOILLIS verificar quando da erro
          // err => {
          //   this.$store.commit('snackbar/change_values', {
          //     text: 'O convite para participar da empresa foi excluido! Portanto foi criado uma empresa só para você!',
          //     color: 'error',
          //     timeout: 7000,
          //     dialog: true
          //   })
          //   // caso o convite da empresa seja excluido, será criado uma nova empresa para o usuário
          //   this.createCompany()
          //   this.loading = false
          //   console.log(err)
          // }
          // ---------- ILLISTODOILLIS verificar quando da erro
        }, err => {
          this.loading = false
          this.$store.commit('loader/change_dialog', false)
          if (err.body.message === 'limitExceeded') {
            this.snackbar = { active: true, text: 'Essa empresa já excedeu o limite de usuários. Solicite ao administrador da empresa que realize um upgrade do plano!', color: 'warning' }
          } else if (err.body.message === 'linkExceeded') {
            this.snackbar = { active: true, text: 'Essa empresa desabilitou o convite de usuários por link.', color: 'warning' }
          } else if (err.body.message === 'registerError') {
            alert('ocorreu um erro em sua conexão! favor registrar novamente!')
          } else {
            this.snackbar = { active: true, text: 'Solicitação falhou', color: 'error' }
          }
        })
      },
      clickReturn () {
        // estrutura utm criada para rastrear de qual campanha e qual termo o usuário usou
        let routerTracking = document.URL.split('?')[1]
        this.$router.push(`/login?${routerTracking}`)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auth/Register.vue